var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "HistoryModal",
            size: "xl",
            "content-class": "menu-bg-blue-transparent-modal rh-modal",
            title: "Release History",
            "hide-footer": "",
          },
          on: {
            show: function ($event) {
              return _vm.getHistory()
            },
          },
        },
        [
          _c("vue-bootstrap4-table", {
            attrs: {
              rows: _vm.releaseRows,
              columns: _vm.releaseColumns,
              config: _vm.config,
              classes: _vm.classes,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }